import { css } from '@emotion/react';
import { navigate, PageProps, Link } from 'gatsby';
import { useEffect } from 'react';
import { ContactPageTemplate } from '@/components/contact/ContactPageTemplate';
import { ContactForm } from '@/components/form/ContactForm';
import { Layout } from '@/components/general/Layout';
import { Seo } from '@/components/general/Seo';
import { pagesPath } from '@/lib/pagesPath';
import { useFormStorage } from '@/lib/use-form-storage';
import { getScreen } from '@/styles/media-query';

const Page: React.FC<PageProps> = ({ location }) => {
  const { getFormStorage, setFormStorage, cleanFormStorage } = useFormStorage();
  const formState = getFormStorage();

  useEffect(() => {
    if (formState) {
      return () => {
        cleanFormStorage();
      };
    }
  }, []);

  return (
    <Layout location={location}>
      <Seo
        title="IPO準備クラウドの無料相談・資料請求｜専門アドバイザーが対応【Uniforce】"
        description="【Uniforce】IPO準備でお悩みの方へ。経験豊富な専門アドバイザーが1営業日以内に対応。無料相談では、貴社の状況に合わせた具体的なIPO準備プランをご提案。まずは気軽にご相談ください。資料請求も受付中。"
      />
      <ContactPageTemplate
        title="サービスに関するご相談"
        titleEn="CONTACT"
        titleReadText={
          <>
            Uniforce IPOクラウドや、コンサルティングサービスなど、
            <br />
            弊社サービスに関するお問い合わせは下記フォームよりお願いいたします。
            <br />
            すでにサービスをご契約されている方のお問い合わせは
            <Link to={pagesPath.estimate.$url()} 
              css={css`
                color: #00B3A7;
              `}
            >こちら</Link>。
          </>
        }
        sideTitleEn="Point"
        sideTitleJa="Uniforce導入のメリット"
        sideItems={[
          '上場経験がなくてもスムーズに準備を進められるようになる',
          '成長を視野に入れた内部統制構築・運用ができるようになる',
          '監査契約前に自社の内部統制状況をセルフチェックできる',
          '公認会計士によるIPO準備業務の徹底サポートを受けられる',
        ]}
        type="contact"
      >
        <ContactForm
          initFormState={{
            ...formState,
            agree_flag: false,
          }}
          submitHandler={async (state) => {
            setFormStorage(state);
            await navigate(pagesPath.contact.confirmation.$url());
          }}
        />
      </ContactPageTemplate>
    </Layout>
  );
};

export default Page;
